import { loadCompany } from 'actions/profile';
import { createReducerAsync } from 'redux-act-async';

const reducer = createReducerAsync(loadCompany);

reducer.on(
  'UPLOAD_LOGO_OK',
  (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      logoId: payload.response.imageId,
    },
  }),
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/company.js